import { customerApi } from "../../utils/apiConfig";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const setDofIstek = (payload) => {
  return customerApi.post("/setDofIstek", payload, authHeaders());
};

// scope: "all" (yetkinin izin verdiği tümü) | "assigned" (bana atananlar) | "created" (benim açtıklarım)
export const getDofIstekler = (scope = "all") => {
  return customerApi.get("/getDofIstekler", {
    ...authHeaders(),
    params: { scope },
  });
};

export const getDofIstekById = (id) => {
  return customerApi.get(`/getDofIstekById/${id}`, authHeaders());
};

export const updateDofIstek = (payload) => {
  // payload içerisinde { id, ...guncellenecekVeriler } bulunmalı
  return customerApi.post("/updateDofIstek", payload, authHeaders());
};

export const deleteDofIstek = (id) => {
  return customerApi.post("/deleteDofIstek", { id }, authHeaders());
};

// Atanan kişilere bildirim mailini tekrar gönderir
export const resendDofMail = (id) => {
  return customerApi.post("/resendDofMail", { id }, authHeaders());
};

// İş akışı: save | submit | approve | reject | close | return | reopen
export const dofWorkflowAction = (id, action, { note, data } = {}) => {
  return customerApi.post(
    "/dofWorkflowAction",
    { id, action, ...(note ? { note } : {}), ...(data ? { data } : {}) },
    authHeaders()
  );
};
